/**
 * External dependencies.
 */
import { has, isEmpty } from 'lodash';

/**
 * WordPress dependencies
 */
import { addFilter } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

addFilter( `gutenify--${ hookPrefix }--inline-styles`, `gutenify--${ hookPrefix }--inline-styles--core`, ( css, props ) => {
	const { blockAdvanceOptions, blockClientId } = props.attributes;
	const { columns } = blockAdvanceOptions;
	const selector = `.gutenify-section-${ blockClientId }`;

	const innerStyleVars = `${ columns ? `--gutenify--grid-template-columns: ${ columns };` : '' }`;
	if ( innerStyleVars ) {
		css += `${ selector } { ${ innerStyleVars } }`;
	}

	return css;
} );
